import { FC } from "react";
import { styled } from "@mui/material/styles";
import { useAccount, useConnect, useDisconnect } from "wagmi";
import { InjectedConnector } from "wagmi/connectors/injected";
import { OutlinedButton } from "../Buttons";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { conciseAddress } from "../../utils/formatter";

const ConnectWalletButton: FC = () => {
  const { address, isConnected } = useAccount();
  const { connect } = useConnect({
    connector: new InjectedConnector(),
  });
  const { disconnect } = useDisconnect();

  if (isConnected)
    return (
      <OutlinedButton
        onClick={() => disconnect()}
      >
        {address && conciseAddress(address)}
      </OutlinedButton>
    );
  return (
    <OutlinedButton onClick={() => connect()}>Connect Wallet</OutlinedButton>
  );
};

export default ConnectWalletButton;
